import React, {FC} from 'react';
import Modal from "./ui/Modal";
import {useTranslation} from "react-i18next";

interface GpsrNotSavedFormModalProps {
    open: boolean;
    onClose: () => void;
    onCancel: () => void;
}

const GpsrNotSavedFormModal: FC<GpsrNotSavedFormModalProps> = ({open, onClose, onCancel}) => {
    const {t} = useTranslation();
    return (
        <Modal hideCloseButton={true} isCentered={true} isOpen={open} onClose={onClose} title={t('gpsr:modal_form_questions_title')}>
            <div className='gpsr-modal-body-wrapper'>
                <div className='gpsr-modal-body-text'>
                    {t('gpsr:modal_form_questions_text')}
                </div>

                <div className='gpsr-modal-body-buttons'>
                    <button onClick={onCancel} className='modal-button cancel-delete'>
                        {t('cancelText')}
                    </button>

                    <button className='modal-button confirm-delete ml-24' onClick={onClose}>
                        {t('gpsr:get_out_btn')}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default GpsrNotSavedFormModal;